"use server";

import { revalidatePath } from "next/cache";
import { redirect } from "next/navigation";
import { prisma } from "@/lib/prisma";
import { belepesKotelezo } from "@/lib/auth";
import type { AjanlatkeresForras, AjanlatkeresStatusz } from "@/generated/prisma";

function ures(ertek: FormDataEntryValue | null) {
  const szoveg = String(ertek || "").trim();
  return szoveg === "" ? null : szoveg;
}

export async function ajanlatkeresBekuldese(formData: FormData) {
  const oldal = String(formData.get("vissza_oldal") || "/ajanlatkeres");
  const kapcsolat_nev = String(formData.get("kapcsolat_nev") || "").trim();
  const kapcsolat_email = String(formData.get("kapcsolat_email") || "").trim().toLowerCase();
  const forras = String(formData.get("forras") || "WEBOLDAL_AJANLATKERES") as AjanlatkeresForras;

  if (!kapcsolat_nev || !kapcsolat_email) {
    redirect(`${oldal}?hiba=hianyzo_adat`);
  }

  const masodlagos_ertek = ures(formData.get("masodlagos_valaszto"));
  const masodlagos_cimke = ures(formData.get("masodlagos_valaszto_cimke")) || "Igényelt szolgáltatás";
  const igeny_leiras = ures(formData.get("igeny_leiras"));
  const teljes_leiras = [masodlagos_ertek ? `${masodlagos_cimke}: ${masodlagos_ertek}` : null, igeny_leiras]
    .filter(Boolean)
    .join("\n\n");

  await prisma.ajanlatkeres.create({
    data: {
      kapcsolat_nev,
      kapcsolat_email,
      kapcsolat_telefon: ures(formData.get("kapcsolat_telefon")),
      cim_szabad_szoveg: ures(formData.get("cim_szabad_szoveg")),
      forras,
      igeny_leiras: teljes_leiras || null,
      helyszini_felmeres_szukseges: formData.get("helyszini_felmeres_szukseges") === "on",
    },
  });

  redirect(`${oldal}?siker=1`);
}

export async function ajanlatkeresFrissites(formData: FormData) {
  await belepesKotelezo();

  const id = String(formData.get("id") || "");
  const statusz = String(formData.get("statusz") || "") as AjanlatkeresStatusz;
  if (!id || !statusz) return;

  const ertekesito_id = ures(formData.get("ertekesito_id"));

  await prisma.ajanlatkeres.update({
    where: { id },
    data: { statusz, ertekesito_id },
  });

  revalidatePath("/admin/ajanlatkeresek");
  revalidatePath(`/admin/ajanlatkeresek/${id}`);
}
